import React from "react";
import './Link.css';


const Link3 = () => {
  return (
    <div className="links">
    <div className="container">
    <div className="column">
    <h3 className="perfect" style={{marginTop : "170px"}}>Changing a CO<sub>2</sub> cylinder(David Dispense System)</h3>
    <br />
    </div>

    <div className="cardstart" style={{marginTop : "30px"}}>
     <div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link31a.webp">
          <source src="link31a.mp4" type="video/mp4" />
        </video>
              </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardf-description"> <b>Step 1 : </b>Check if the CO2 cylinder is empty
        <b style={{fontWeight:'500', fontSize:'1rem' , marginLeft:'5px'}}>The button cannot be engaged may be due to
           - The CO2 cylinder not turned on (turn the cylinder knob anti-clockwise and try to press the button again)
           - The CO2 cylinder is empty</b> </h5>
      </div>
    </div>

     
<div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link32a.webp">
          <source src="link32a.mp4" type="video/mp4" />
        </video>
              </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardf-description"> <b>Step 2 :  </b>Turn off the CO2 cylinder by turning the cylinder knob clockwise
        <b style={{fontWeight:'500', fontSize:'1rem' , marginLeft:'5px'}}>(IMPORTANT) Ensure that the knob is fully turned (hand-tight) before pulling on the release key to release remaining pressure</b></h5>
      </div>
    </div>
 
    <div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link33a.webp">
          <source src="link33a.mp4" type="video/mp4" />
        </video>
              </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardf-description"> <b>Step 3 :  </b>Use the attached spanner to loosen the nut connecting the cylinder and regulator before unscrewing it </h5>
      </div>
    </div>

    <div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link34a.webp">
          <source src="link34a.mp4" type="video/mp4" />
        </video>
              </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardf-description"> <b>Step 4 :  </b>Ensure that there is a washer on the regulator before connecting to a new cylinder
        <b style={{fontWeight:'500', fontSize:'1rem' , marginLeft:'5px'}}> (IMPORTANT) The washer MUST be present to prevent gas leaks</b>
       </h5>
      </div>
    </div>

    <div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link35a.webp">
          <source src="link35a.mp4" type="video/mp4" />
        </video>
              </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardf-description"> <b>Step 5 :  </b>Connect the regulator to a new cylinder and tighten the nut with the attached spanner
        <b style={{fontWeight:'500', fontSize:'1rem' , marginLeft:'5px'}}>(IMPORTANT) Double check that the nut is properly tightened</b> </h5>
      </div>
    </div>

    <div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link36a.webp">
          <source src="link36a.mp4" type="video/mp4" />
        </video>
              </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardf-description"> <b>Step 6 :  </b>Turn on the CO2 cylinder by turning the knob anti-clockwise</h5>
      </div>
    </div>

    <div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link37a.webp">
          <source src="link37a.mp4" type="video/mp4" />
        </video>
              </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardf-description"> <b>Step 7 :  </b>Engage the dispenser by pressing on the button to start the flow of CO2 </h5>
      </div>
    </div>

    
      
    </div>
    </div>
    </div>

    )
}

export default Link3;
